import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  background: #fafafa;
  font-family: 'Poppins', sans-serif;
  color: #333;
  font-size: 0.9rem;
  line-height: 1.6;
`;

export const PageHeader = styled.div`
  padding: 1.5rem 2rem 1rem;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const PageHeaderLeft = styled.div``;

export const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
  letter-spacing: -0.3px;
  margin: 0;
`;

export const PageSubtitle = styled.p`
  font-size: 0.85rem;
  color: #999;
  margin: 0.25rem 0 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const PreviewBanner = styled.div`
  margin: 0 2rem;
  background: linear-gradient(135deg, rgba(233, 112, 36, 0.06), rgba(233, 112, 36, 0.02));
  border: 1px solid rgba(233, 112, 36, 0.2);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.82rem;
  color: #9a4d12;
  flex-shrink: 0;
`;

export const BodyLayout = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
`;

export const CenterColumn = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fafafa;
  padding: 0 1.5rem;
`;

export const FilterSection = styled.div`
  flex-shrink: 0;
  margin-bottom: 0.75rem;
`;

export const MainScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 0 1.5rem;
`;

export const FilterBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.span`
  font-size: 0.75rem;
  font-weight: 300;
  color: #000;
  letter-spacing: 1px;
  text-transform: uppercase;
  white-space: nowrap;
`;

export const FilterDivider = styled.div`
  width: 1px;
  height: 20px;
  background: #e0e0e0;
  margin: 0 0.15rem;
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 200px;
  max-width: 420px;

  svg {
    position: absolute;
    left: 0.6rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.4rem 0.75rem 0.4rem 2rem;
  font-size: 0.82rem;
  color: #333;
  font-family: 'Poppins', inherit;
  outline: none;
  transition: all 0.2s ease;

  &::placeholder { color: #999; }
  &:focus {
    background: #fff;
    border-color: #e97024;
    box-shadow: 0 0 0 2px rgba(233, 112, 36, 0.2);
  }
`;

export const FilterPill = styled.button`
  border: 1px solid ${(p) => (p.$active ? '#e97024' : '#e0e0e0')};
  background: ${(p) => (p.$active ? '#e97024' : '#fff')};
  color: ${(p) => (p.$active ? '#fff' : '#666')};
  border-radius: 999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.78rem;
  font-weight: 500;
  font-family: 'Poppins', inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    border-color: #e97024;
    color: ${(p) => (p.$active ? '#fff' : '#e97024')};
  }
`;

export const FilterMeta = styled.span`
  font-size: 0.78rem;
  color: ${(p) => (p.$warn ? '#92400e' : '#666')};
  font-weight: ${(p) => (p.$warn ? 600 : 400)};
  margin-left: auto;
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;

export const DropdownTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 0.3rem 0.625rem;
  font-size: 0.82rem;
  color: #333;
  font-family: 'Poppins', inherit;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;

  &:hover, &[data-open='true'] {
    background: #fff;
    border-color: #e97024;
    box-shadow: 0 0 0 2px rgba(233, 112, 36, 0.2);
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  z-index: 200;
  display: ${(p) => (p.$open ? 'block' : 'none')};
  animation: ${fadeIn} 0.15s ease;
`;

export const DropdownItem = styled.div`
  padding: 0.5rem 0.75rem;
  font-size: 0.82rem;
  cursor: pointer;
  background: ${(p) => (p.$selected ? 'rgba(233, 112, 36, 0.08)' : 'transparent')};
  color: ${(p) => (p.$selected ? '#e97024' : '#333')};
  font-weight: ${(p) => (p.$selected ? 600 : 400)};

  &:hover {
    background: rgba(233, 112, 36, 0.06);
  }
`;

export const PanelStatRow = styled.div`
  padding: 0.625rem 1.5rem;
  border-bottom: 1px solid #f5f5f5;
`;

export const PanelStatLabel = styled.div`
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999;
  margin-bottom: 0.25rem;
`;

export const PanelStatValue = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
`;

export const PanelListItem = styled.div`
  padding: 0.625rem 1.5rem;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  background: ${(p) => (p.$active ? 'rgba(233, 112, 36, 0.06)' : 'transparent')};

  &:hover {
    background: ${(p) => (p.$active ? 'rgba(233, 112, 36, 0.06)' : '#ffefe7')};
  }
`;

export const IssueCode = styled.span`
  font-size: 0.7rem;
  font-weight: 700;
  color: #e97024;
  display: block;
  margin-bottom: 0.2rem;
`;

export const IssueTopic = styled.div`
  font-size: 0.82rem;
  font-weight: 500;
  color: #333;
  line-height: 1.35;
`;

export const IssueMeta = styled.div`
  font-size: 0.72rem;
  color: #999;
  margin-top: 0.25rem;
`;

export const StatusPill = styled.span`
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${(p) => {
    if (p.$status === 'open') return 'rgba(239, 68, 68, 0.12)';
    if (p.$status === 'in_progress') return 'rgba(245, 158, 11, 0.15)';
    if (p.$status === 'resolved' || p.$status === 'complete') return 'rgba(16, 185, 129, 0.15)';
    return 'rgba(16, 185, 129, 0.15)';
  }};
  color: ${(p) => {
    if (p.$status === 'open') return '#dc2626';
    if (p.$status === 'in_progress') return '#d97706';
    return '#059669';
  }};
`;

export const LoadingWrap = styled.div`
  padding: 3rem;
  text-align: center;
`;

export const ErrorText = styled.div`
  padding: 2rem;
  text-align: center;
  color: #dc2626;
`;
